import { useTranslation } from 'react-i18next';

export type ErrorStateActionsProps = {
  onRetry: () => void;
  onBack: () => void;
};

export default function ErrorStateActions({ onRetry, onBack }: ErrorStateActionsProps) {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <button
        onClick={onRetry}
        className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
      >
        {t('common.retry')}
      </button>
      <button
        onClick={onBack}
        className="w-full px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
      >
        {t('common.back')}
      </button>
    </div>
  );
}
